import { ReactElement, ReactNode } from "react"
import { useParams } from "react-router-dom"

import CreateEbDeviceProvider from "./baseProviders/createEbDeviceProvider"
import useContinueEbDeviceDraft from "../../../../../services/middleware/hooks/devices/lct/useContinueEbDeviceDraft"

interface IContinueEbDeviceVersionUrlParams {
    deviceRef: string
}

interface IContinueEbDeviceVersionProviderProps {
    children: ReactNode
}

const ContinueEbDeviceVersionProvider = ({
    children,
}: IContinueEbDeviceVersionProviderProps): ReactElement => {
    const { deviceRef: urlDeviceRef } = useParams<
        keyof IContinueEbDeviceVersionUrlParams
    >() as IContinueEbDeviceVersionUrlParams

    const {
        data: formData,
        setData: setFormData,
        isLoading,
        error: continueVersionError,
        attachmentUUID,
    } = useContinueEbDeviceDraft(urlDeviceRef)

    return (
        <CreateEbDeviceProvider
            formData={formData}
            setFormData={setFormData}
            formDataIsLoading={isLoading}
            formDataError={continueVersionError}
            attachmentUUID={attachmentUUID ?? undefined}
            systemReference={urlDeviceRef}
            canEditManufacturer={false}
        >
            {children}
        </CreateEbDeviceProvider>
    )
}

export default ContinueEbDeviceVersionProvider
